import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, of, race, retry, switchMap, timer } from 'rxjs';
import { randomString } from '../lib/random-string';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private http = inject(HttpClient);

  online$ = race([
    new Observable(observer => {
      const onlineHandler = () => {
        observer.next(true);
        observer.complete();
      };
      if (window.navigator.onLine) return onlineHandler();
      window.addEventListener('online', onlineHandler, { passive: true });
      return () => window.removeEventListener('online', onlineHandler);
    }),
    timer(10_000).pipe(switchMap(() => this.http.head(`/assets/network-test.json?cachebust=${randomString(12)}`))),
  ]).pipe(
    retry(),
    map(() => true)
  );

  isCurrentlyOnline = () => {
    if (!window.navigator.onLine) return of(false);
    return this.http.head(`/assets/network-test.json?cachebust=${randomString(12)}`).pipe(
      map(() => true),
      retry()
    );
  };
}
